<template>
  <div class="content has-text-centered">
    <p>
      <img width="200" src="~assets/images/vti.png" :alt="description">
    </p>

  </div>
</template>

<script>
export default {

  data () {
    return this.$store.state.pkg
  }

}
</script>

<style lang="scss" scoped>
.is-title {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Home.vue?76bcc692